import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

interface PriceDetailsProps {
  className?: string;
  children?: React.ReactNode;
}

const PriceDetails: FC<PriceDetailsProps> = ({ children, className }) =>
  children ? (
    <StyledPriceDetails className={className}>{children}</StyledPriceDetails>
  ) : null;

const StyledPriceDetails = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default PriceDetails;
